import React, { useEffect }  from 'react';

export default (props) => {           
     
    const getClass = (entries) => {
       
        let res = "blue";
        
        if(entries === null){
            
            res = "red";
        }
        else if(entries.entry === null){
            
            res = "black";
        }
                                   
        return "ingredient-title "+res;
    };
    
    
    const drawAnnexes = (entries) => {
        
        let res = "";
        
        if(entries?.annex_ii){
            
            res += "II/"+entries.annex_ii+" ";
        }
        
        if(entries?.annex_iii){
            
            res += "III/"+entries.annex_iii+" ";
        }
        
        if(entries?.annex_iv){
            
            res += "IV/"+entries.annex_iv+" ";
        }
        
        if(entries?.annex_v){
            
            res += "V/"+entries.annex_v+" ";
        }
        
        if(entries?.annex_vi){
            
            res += "VI/"+entries.annex_vi;
        }
        
        return res;
    };
    

    const drawCorrectionButton = (entries) => {
        
        const res = [];
        
        if(entries === null){
            
            if(!props.corrections){
                
                res.push(

                    <button class="proposals-button button-red" onClick={() => props.onCorrect(props.ingredient_index)}>
                        Afficher les corrections possibles
                    </button>
                ); 
            }
        }
        
        return res;
    };
    
    const onClickTitle = () => {

        props.onShowDetails(props.ingredient_index);
    }; 
    
    
    return (

        <div>
            <div 
                class   = {getClass(props.entries)}
                onClick = {onClickTitle}>
                {props.ingredient} <span class="annexes">{drawAnnexes(props.entries)}</span>
                <div>{drawCorrectionButton(props.entries)}</div>                       
                {   
                    props.corrections ? 
                    <div style={{marginTop:"20px"}}>                        
                        {
                            props.corrections.map( entry => {

                                return  <div 
                                            class   = "correction"
                                            onClick = {() => props.onSelectCorrection(props.ingredient_index, entry)}>
                                            {entry.ingredient}
                                        </div>
                            })
                        }
                    </div>
                    : ""               
                }
            </div>
        </div>
    );
}

